// SOF-2339: while editing an appointment, a price the staff member typed into
// the cost field (Formik marks it touched; service changes clear that flag) is
// kept when the performing staff member changes. Service changes still reset
// the price, and new appointments keep applying the staff tier price.
export const keepsCustomCostOnStaffChange = (form) => (
  form?.values?.form_types === "edit_appointment"
  && Boolean(form?.touched?.cost)
  && String(form?.values?.cost ?? "").trim() !== ""
);
